<section role="main">
  <header role="heading">
    <div class="container">
      <div class="row">
        <div class="col-md-8 col-sm-6 col-xs-6">
          <h2>Bem vindo(a) &nbsp; Candidato</h2>
        </div>
        <pmv-loading [isLoading]="loading"></pmv-loading>
      </div>
    </div>
  </header>
  <fieldset class="section">
    <div class="container" style="padding-left: 3px;">
      <p-tabView class="col-md-10 tabclass"  (onChange)="onTabChange($event)">
        <p-tabPanel header="Processo Seletivo">
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-sm-6 col-xs-6">
                <h2>
                  <a id="irconteudo">Processo Seletivo</a>
                </h2>
                <p>Situações dos Processos Seletivos</p>
              </div>
              <div class="col-md-6 text-right">
                <a style="color:#fff;" (click)="abrirLogin()" class="btn btn-primary btn-sm" routerLinkActive="active">Efetuar Login</a>
                <button id="irmenu" class="btn btn btn-warning btn-sm" data-toggle="modal" data-target=".bs-example-modal-lg">
                  <span class="glyphicon glyphicon-question-sign"></span>
                  Aviso
                </button>
                <a (click)="abrirDiarioOficial()" class="hands" ><i class="glyphicon glyphicon-link" style="padding:8px; border-radius:100px; border:1px solid #ccc; background-color:#fff"></i> Consultar diário oficial</a>
              </div>
            </div>
          </div>
          <div class="container">
            <form #form="ngForm">
              <div class="row">
                <div class="col-md-12" style="margin-bottom: 10px;">
                  <a style="color: #2D699F;" [routerLink]="" (click)="abrirEdital(1,3)">
                    <div runat="server" id="divAberta" class="col-md-6" visible="false">
                      <div class="panel" style="border: 1px solid #4caf50;">
                        <div class="panel-heading" style="color: #fff; background-color: #4caf50;">
                          <div class="row">
                            <div class="col-md-2 col-xs-6">
                              <i class="fa fa-check-circle fa-3x"></i>
                            </div>
                            <div class="col-md-10 col-xs-6 text-right">
                              <div>
                                <span class="fontsize">Inscrições Abertas</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="panel-footer">
                          <div class="row text-center">
                            <span> <strong> {{qtdAberta}} </strong> Editais com inscrições abertas. Aproveite!</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                  <a style="color: #2D699F;" [routerLink]="" (click)="abrirEdital(2,3)">
                    <div runat="server" id="divAndamento" class="col-md-6" visible="false">
                      <div class="panel" style="border: 1px solid #FFCC00;">
                        <div class="panel-heading" style="color: #fff; background-color: #FFCC00;">
                          <div class="row">
                            <div class="col-md-2 col-xs-6">
                              <i class="fa fa-chevron-circle-right fa-3x"></i>
                            </div>
                            <div class="col-md-10 col-xs-6 text-right">
                              <div>
                                <span class="fontsize">Em Andamento</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="panel-footer">
                          <div class="row text-center">
                            <span> </span>
                            <span> <strong> {{qtdEmAndamento}} </strong> Editais em andamento.</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                  <a style="color: #2D699F;" [routerLink]="" (click)="abrirEdital(3,3)">
                    <div runat="server" id="divEncerrada" class="col-md-6" visible="false">
                      <div class="panel" style="border: 1px solid #FF7F00;">
                        <div class="panel-heading" style="color: #fff; background-color: #FF7F00;">
                          <div class="row">
                            <div class="col-md-2 col-xs-6">
                              <i class="fa fa-times-circle fa-3x"></i>
                            </div>
                            <div class="col-md-10 col-xs-6 text-right">
                              <div>
                                <span class="fontsize">Encerrados</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="panel-footer">
                          <div class="row text-center">
                            <span> <strong> {{qtdEncerrado}} </strong> Editais encerrados.</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                  <a style="color: #2D699F;" [routerLink]="" (click)="abrirEdital(4,3)">
                    <div runat="server" id="divProximo" class="col-md-6" visible="false">
                      <div class="panel" style="border: 1px solid #2D699F;">
                        <div class="panel-heading" style="color: #fff; background-color: #2D699F;">
                          <div class="row">
                            <div class="col-md-2 col-xs-6">
                              <i class="fa fa-plus-circle fa-3x"></i>
                            </div>
                            <div class="col-md-10 col-xs-6 text-right">
                              <div>
                                <span class="fontsize">Próximos</span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="panel-footer">
                          <div class="row text-center">
                            <span> <strong> {{qtdProximo}} </strong> Fique atento aos próximos editais!</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </form>
            <div class="row">
              <div class="col-md-12">
                <div class="pull-right">
                  <a style="color:#fff;" (click)="abrirEdital(0,3)" class="btn btn-primary" routerLinkActive="active">Pesquisa Avançada</a>
                </div>
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Concurso Público" [disabled]="false">
          <div class="container">
            <div class="row">
              <div class="col-md-6 col-sm-6 col-xs-6">
                <h2>
                  <a id="irconteudo">Concurso Público</a>
                </h2>
                <p>Situações dos Concursos</p>
              </div>
              <div class="col-md-6 text-right">
                <a style="color:#fff;" (click)="abrirLogin()" class="btn btn-primary btn-sm" routerLinkActive="active">Efetuar Login</a>
                <button id="irmenu" class="btn btn btn-warning btn-sm" data-toggle="modal" data-target=".bs-example-modal-lg">
                  <span class="glyphicon glyphicon-question-sign"></span>
                  Aviso
                </button>
                <a (click)="abrirDiarioOficial()" class="hands" ><i class="glyphicon glyphicon-link" style="padding:8px; border-radius:100px; border:1px solid #ccc; background-color:#fff"></i> Consultar diário oficial</a>
              </div>
          </div>
          </div>
          <div class="container">
            <div class="row">
              <div class="col-md-12" style="margin-bottom: 10px;">
                <a style="color: #2D699F;" [routerLink]="" (click)="abrirEdital(1,1)">
                  <div runat="server" id="divAberta" class="col-md-6" visible="false">
                    <div class="panel" style="border: 1px solid #4caf50;">
                      <div class="panel-heading" style="color: #fff; background-color: #4caf50;">
                        <div class="row">
                          <div class="col-md-2 col-xs-6">
                            <i class="fa fa-check-circle fa-3x"></i>
                          </div>
                          <div class="col-md-10 col-xs-6 text-right">
                            <div>
                              <span class="fontsize">Inscrições Abertas</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="panel-footer">
                        <div class="row text-center">
                          <span> <strong> {{qtdAberta}} </strong> Editais com inscrições abertas. Aproveite!</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a style="color: #2D699F;" [routerLink]="" (click)="abrirEdital(2,1)">
                  <div runat="server" id="divAndamento" class="col-md-6" visible="false">
                    <div class="panel" style="border: 1px solid #FFCC00;">
                      <div class="panel-heading" style="color: #fff; background-color: #FFCC00;">
                        <div class="row">
                          <div class="col-md-2 col-xs-6">
                            <i class="fa fa-chevron-circle-right fa-3x"></i>
                          </div>
                          <div class="col-md-10 col-xs-6 text-right">
                            <div>
                              <span class="fontsize">Em Andamento</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="panel-footer">
                        <div class="row text-center">
                          <span> </span>
                          <span> <strong> {{qtdEmAndamento}} </strong> Editais em andamento.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a style="color: #2D699F;" [routerLink]="" (click)="abrirEdital(3,1)">
                  <div runat="server" id="divEncerrada" class="col-md-6" visible="false">
                    <div class="panel" style="border: 1px solid #FF7F00;">
                      <div class="panel-heading" style="color: #fff; background-color: #FF7F00;">
                        <div class="row">
                          <div class="col-md-2 col-xs-6">
                            <i class="fa fa-times-circle fa-3x"></i>
                          </div>
                          <div class="col-md-10 col-xs-6 text-right">
                            <div>
                              <span class="fontsize">Encerrados</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="panel-footer">
                        <div class="row text-center">
                          <span> <strong> {{qtdEncerrado}} </strong> Editais encerrados.</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
                <a style="color: #2D699F;" [routerLink]="" (click)="abrirEdital(4,1)">
                  <div runat="server" id="divProximo" class="col-md-6" visible="false">
                    <div class="panel" style="border: 1px solid #2D699F;">
                      <div class="panel-heading" style="color: #fff; background-color: #2D699F;">
                        <div class="row">
                          <div class="col-md-2 col-xs-6">
                            <i class="fa fa-plus-circle fa-3x"></i>
                          </div>
                          <div class="col-md-10 col-xs-6 text-right">
                            <div>
                              <span class="fontsize">Próximos</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="panel-footer">
                        <div class="row text-center">
                          <span> <strong> {{qtdProximo}} </strong> Fique atento aos próximos editais!</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="pull-right">
                  <a style="color:#fff;" (click)="abrirEdital(0,1)" class="btn btn-primary" routerLinkActive="active">Pesquisa Avançada</a>
                </div>
              </div>
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>

  </fieldset>

</section>
<!-- Modal -->
<div class="modal fade bs-example-modal-lg" id="myModal" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
        <h2 class="modal-title" id="myModalLabel">Aviso ao Candidato</h2>
      </div>
      <div class="modal-body">

        <p><b> Orientações para Acompanhamento dos Concursos Públicos e Processos Seletivos Simplificados.</b></p>
        <p>Prezado Candidato,</p>
        <p style="text-align:justify">Informamos que a partir de <b>21/07/2014</b> os Atos Oficiais do Município
          passaram a ser publicados no Diário Oficial de Vitória, criado pela Lei nº 8.604 de 23 de dezembro de 2013,
          não se responsabilizando o Município por matérias jornalísticas.

          <br /><br />Através do endereço eletrônico <b><a href="http://diariooficial.vitoria.es.gov.br"
              class="targetblank" title="Diário Oficial do Município">diariooficial.vitoria.es.gov.br</a></b> é
          possível consultar todos os atos do Poder Executivo, como leis, decretos, portarias, editais e outros.

          <br /><br />As publicações dos Editais de Concursos Públicos e Processos Seletivos Simplificados ocorrerão
          preferencialmente às sextas-feiras no Diário Oficial de Vitória, estando disponíveis para consulta neste
          portal de Processo Seletivo do Município a partir das 10 horas do mesmo dia de publicação.

          <br /><br />Para acompanhar as publicações dos editais de Concursos Públicos e/ou Processos Seletivos
          Simplificados em vigência, acesse os respectivos menus <b>Em Andamento</b> que se encontram ao lado. Após
          isso, será exibida uma listagem de cargos/funções em ordem alfabética para escolha e, ao clicar no item
          desejado, serão apresentados os editais de seleção com suas respectivas publicações. Na opção <b>Publicações
            Anteriores a 2013</b>, estão disponíveis às realizadas até 31/12/2012.

          <br /><br />Será preciso efetuar login, através do nº do CPF e senha, para acessar as opções do menu
          <b>Candidato</b> e em caso de dúvidas estamos à disposição no telefone (27) 3382-6071.

          <br /><br />Cordialmente,
          <br />Coordenação de Recrutamento e Seleção
          <br />Gerência de Recrutamento, Seleção e Registro</p>

      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/pages/home/home.component.html